import * as React from 'react';
import Svg, {Path, SvgProps} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={22}
    height={18}
    viewBox="0 0 22 18"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#070A7A'}
      d="M21.81 9.28c0-.29-.09-.46-.2-.58l-6.04-7.44c-.29-.4-.93-.47-1.34-.14-.4.33-.43.94-.1 1.3l4.81 5.93H1.36c-.51 0-.93.42-.93.93s.42.93.93.93h17.58l-4.81 5.93c-.37.37-.26 1.01.13 1.36.3.27 1.1.18 1.31-.19l6.04-7.44c.16-.19.21-.34.2-.58v-.01Z"
    />
  </Svg>
);
export default SvgComponent;
